<template>
  <transition name="page" mode="out-in">
    <slot>
      <main role="main" class="col-md-9 col-lg-10 px-4 pt-4" :class="{'ml-sm-auto': user, 'mx-auto' : !user}">
        <router-view/>
      </main>
    </slot>
  </transition>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'Child',
  middleware: 'auth',
  computed: mapGetters({
    user: 'auth/user'
  }),
}
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/Child.vue